import React from "react";
import cx from "classnames";

import ReadyForDelivery from "../ReadyForDelivery";

// @ts-ignore (fix me please, do not replicate)
const ValueProp = ({ heading, description }) => (
  <div className="mb-lg overflow-hidden">
    <p className="font-extrabold mb-xs text-md">{heading}</p>
    <p>{description}</p>
  </div>
);

const DeliveryFromLeafly = ({
  className,
  showCTA,
}: {
  className?: string;
  showCTA?: boolean;
}) => {
  return (
    <section className={className}>
      <div className="container">
        <h2 className="mb-xl mt-xl text-center text-xxl">How delivery works</h2>
        <div
          className={cx(
            "flex flex-col items-center md:flex-row md:text-left text-center justify-center mb-xxl pb-lg md:m-0 md:p-0",
            { "justify-center md:text-center": !showCTA },
          )}
        >
          <div
            className={cx("flex flex-col justify-between", {
              "lg:col-1/3": !showCTA,
              "pr-xxl": showCTA,
            })}
          >
            <ValueProp
              heading="Shop local"
              description={
                <>
                  <span className="block lg:inline">
                    Enter your address to shop legal{" "}
                  </span>
                  <span className="block lg:inline">
                    delivery dispensaries nearby.
                  </span>
                </>
              }
            />
            <ValueProp
              heading="Order it up"
              description={
                <>
                  <span className="block lg:inline">
                    THC, CBD, vapes, wax, pre-rolls,{" "}
                  </span>
                  <span className="block lg:inline">
                    whatever! It’s legal, friends.
                  </span>
                </>
              }
            />
            <ValueProp
              heading="Keep an eye out"
              description={
                <>
                  <span className="block lg:inline">
                    Your store will text or email you with{" "}
                  </span>
                  <span className="block lg:inline">
                    updates. Have your ID and payment ready.
                  </span>
                </>
              }
            />
          </div>
          <div className="lg:col-11 w-full">
            <ReadyForDelivery className="flex py-lg hidden md:block rounded shadow-lg w-full" />
          </div>
        </div>
      </div>
      <ReadyForDelivery className="md:hidden" />
    </section>
  );
};

export default DeliveryFromLeafly;
